enum ETabCode {
  INFO = 'info',
  TARGET = 'target',
}

enum ELinkType {
  LINK = 'link',
  LINK_ANCHOR = 'link-anchor',
  EMAIL = 'email',
  PHONE = 'phone',
}

enum EProtocol {
  HTTP = 'http:',
  HTTPS = 'https:',
}

enum ETarget {
  NOT_SET = 'not-set',
  BLANK = '_blank',
  TOP = '_top',
  SELF = '_self',
  PARENT = '_parent',
}

enum ELinkRel {
  NOFOLLOW = 'nofollow',
  SPONSORED_NOFOLLOW = 'sponsored nofollow',
}

type TLinkFormData = {
  text: string
} & (
  | {
      linkType: ELinkType.LINK
      href: string
      protocol: EProtocol
      rel: ELinkRel | null
      target: ETarget
    }
  | {
      linkType: ELinkType.LINK_ANCHOR
      anchorId: string
    }
  | {
      linkType: ELinkType.EMAIL
      subject: string
      body: string
      email: string
    }
  | {
      linkType: ELinkType.PHONE
      phoneNumber: string
    }
)

interface ILinkFormProps {
  data: TLinkFormData
  checkAllowedIndexingSettings: () => boolean
  checkDisabledIndexingSettings: () => boolean
}

export { ETabCode, EProtocol, ELinkType, ETarget, ELinkRel }

export type { TLinkFormData, ILinkFormProps }
